import axios from 'axios';
import { getAssetUrl } from '../../../util';

export const RichTextEditorService = {
  uploadImage: async file => {
    const formData = new FormData();
    formData.append('illustration', file);

    const response = await axios.post('/api/v1/admin/allPost/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return getAssetUrl(response.data.url);
  },
};
